<template>
  <div class="creative-forms">
    <ComponentBasedCreativeForm
      v-for="(group, index) in groups"
      :key="index + '' + creativeGroupIndex"
      v-show="creativeGroupIndex === index"
      ref="creative-form"
      v-bind="{ group, brandList, profileList, barrageList, promotedObjectChannelList, officialAccountList }"
      @update-group="updateGroup"
    >
      <template v-slot:selectedmaterials>
        <div class="upload-row">
          <template v-if="carouselMaterialType">
            <el-button type="primary" v-if="materialLen < 3" @click="showCarouselSelector">
              {{ isCarouselThreeImage ? '选择轮播三图' : '选择轮播三视频' }}
            </el-button>
            <span>（{{ materialLen }}/3）</span>
          </template>
          <template v-else>
            <el-button type="primary" v-if="materialLen < 15" @click="showCreativeSelector">选择视频/图片</el-button>
            <el-button type="primary" v-if="materialLen < 15" @click="showCreativeGroupImageSelector">选择组图</el-button>

            <el-dropdown @command="showProceduralImageSelector">
              <el-button style="margin-left: 10px; padding: 10px 15px" type="primary">
                上传组图
                <i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :command="MATERIAL_IMAGE_GROUP_TYPE.THREE_IMAGE">1:1三图</el-dropdown-item>
                <el-dropdown-item :command="MATERIAL_IMAGE_GROUP_TYPE.FOUR_IMAGE">1:1四图</el-dropdown-item>
                <el-dropdown-item :command="MATERIAL_IMAGE_GROUP_TYPE.SIX_IMAGE">1:1六图</el-dropdown-item>
                <el-dropdown-item :command="MATERIAL_IMAGE_GROUP_TYPE.NINE_IMAGE">1:1九图</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>

            <span>（{{ materialLen }}/15）</span>
          </template>
          <el-button type="text" @click="clearAllSelectedMaterials">清空</el-button>
        </div>

        <div v-if="materialLen > 0" class="selected-materials">
          <div class="selected-images">
            <ImageMaterial
              v-for="(img, index) in group.selectedAssets.image"
              :key="img.id"
              v-bind="{ ...img, index }"
              @upload="onMaterialReplace($event, img, index)"
              @remove="onSelectedItemRemove(index, 'image')"
            ></ImageMaterial>
          </div>

          <!-- 组图 -->
          <div class="selected-images">
            <ImageMaterial
              v-for="(item, index) in group.selectedAssets.image_list"
              :key="item.id"
              v-bind="{ ...item, index, showBtn: false }"
              @remove="onSelectedItemRemove(index, 'image_list')"
            >
              <template #material-type>
                <el-tag class="badge">组图{{ index + 1 }}</el-tag>
              </template>
            </ImageMaterial>
          </div>

          <div class="selected-videos">
            <VideoMaterial
              v-for="(video, index) in group.selectedAssets.video"
              :key="video.id"
              v-bind="{ ...video, index }"
              @upload="onMaterialReplace($event, video, index)"
              @remove="onSelectedItemRemove(index, 'video')"
            ></VideoMaterial>
          </div>
        </div>
        <div v-else class="no-material">暂无素材，请上传</div>
      </template>

      <template v-slot:brandbtns>
        <el-button type="text" @click="showAddBrandModal = true">&emsp;+新建</el-button>
        <el-button type="text" @click="getBrandsList" :loading="getBrandListLoading">刷新</el-button>
      </template>

      <template v-slot:profilebtns>
        <el-button type="text" @click="showAddProfileModal = true">&emsp;+新建</el-button>
        <el-button type="text" @click="getProfileList" :loading="getProfileListLoading">刷新</el-button>
      </template>
      <!-- 落地页 -->

      <template v-slot:page v-if="group.pageInfo">
        <el-form-item>
          <LandingPageTagGroup
            v-model="landingPageActiveTag"
            :pageGroup="group.pageInfo"
            @remove="onRemoveLandingPageTag"
            @add="onAddLandingPageTag"
          >
            <template #btn v-if="isMiniGame">
              <span></span>
            </template>
          </LandingPageTagGroup>
        </el-form-item>

        <el-form-item label="落地页跳转类型">
          <el-radio-group v-model="currLandingPageItem.pageType" @change="onLandingPageTypeChange">
            <!-- ios 平台才显示 -->
            <el-radio-button ghost :label="3" v-if="isIOS"> APP STORE </el-radio-button>
            <el-radio-button ghost :label="2" v-if="isAndroid"> 蹊径性能版 </el-radio-button>
            <el-radio-button ghost :label="5" v-if="isAndroid || isIOS"> 官方落地页 </el-radio-button>
            <el-radio-button ghost :label="4" v-if="isMiniGame"> 微信小程序 </el-radio-button>
          </el-radio-group>
        </el-form-item>

        <el-form-item prop="page">
          <el-select v-if="[2].includes(currLandingPageItem.pageType)" v-model="currLandingPageItem.page" value-key="page_id">
            <el-option v-for="item in xijingPages" :key="item.page_id" :label="item.page_name" :value="item"> </el-option>
          </el-select>

          <el-select v-if="[5].includes(currLandingPageItem.pageType)" v-model="currLandingPageItem.page" value-key="page_id">
            <el-option v-for="item in officialPages" :key="item.page_id" :label="item.page_name" :value="item"> </el-option>
          </el-select>
        </el-form-item>
      </template>

      <CreativeTemplateComponents v-model="groups[index]" :planForm="planForm">
        <!-- 标签选择 -->
        <template v-slot:labelbtns>
          <template v-if="group.components.label && group.components.label.length">
            <el-button type="text" @click="labelModal = true"> 修改标签 </el-button>
            <el-button type="text" @click="onClearRemove"> 清空 </el-button>
          </template>
          <el-button type="text" @click="labelModal = true" v-else> +新增标签 </el-button>
        </template>

        <!-- 图文链接创意图片 -->
        <template v-slot:minicardimage>
          <el-avatar
            @click.native="showMiniCardIconSelector"
            shape="square"
            :size="100"
            fit="contain"
            :src="group.components.mini_card_link.mini_card_link_image.url"
          >
            <em class="el-icon-plus"></em>
          </el-avatar>
        </template>

        <!-- 浮层卡片创意图片 -->
        <template v-slot:floatingzoneimage>
          <el-avatar
            @click.native="showFloatingZoneIconSelector"
            shape="square"
            :size="100"
            fit="contain"
            :src="group.components.floating_zone.floating_zone_image.url"
          >
            <em class="el-icon-plus"></em>
          </el-avatar>
        </template>

        <!-- 试玩页结束页图片 -->
        <template v-slot:wxgameplayable>
          <el-avatar
            @click.native="showWxgamePlayableIconSelector"
            shape="square"
            :size="100"
            fit="contain"
            :src="group.components.wxgame_playable_page.wxgame_playable_page_end_cover_img.url"
          >
            <em class="el-icon-plus"></em>
          </el-avatar>
        </template>

        <!-- 组件化创意自动匹配的试玩页图片 -->
        <template v-slot:wxgameplayableimage>
          <el-image
            @click.native="showWxgamePlayableImageSelector"
            style="width: 100px; height: 100px"
            :src="group.components.wxgame_playable_component.card_link_image.url"
            fit="contain"
          >
            <template #error>
              <div class="image-error-placeholder">
                <em class="el-icon-plus"></em>
              </div>
            </template>
          </el-image>
        </template>

        <!-- 组件化创意自动匹配的试玩页结束页图片 -->
        <template v-slot:wxgameplayableendimage>
          <el-image
            @click.native="showWxgamePlayableEndImageSelector"
            style="width: 128px; height: 100px"
            :src="group.components.wxgame_playable_component.end_cover_img.url"
            fit="contain"
          >
            <template #error>
              <div class="image-error-placeholder">
                <em class="el-icon-plus"></em>
              </div>
            </template>
          </el-image>
        </template>
      </CreativeTemplateComponents>
    </ComponentBasedCreativeForm>

    <!-- 选择标签 -->
    <LabelModal v-model="labelModal" :max="3" @on-select="onConfirmLabels"></LabelModal>

    <!-- 添加品牌简介页 -->
    <AddProfileModal
      v-model="showAddProfileModal"
      v-bind="{ accountId: adAccountId, promotedObjectId: planForm.promotedObject.promoted_object_id }"
      @add-confirm="getProfileList"
    ></AddProfileModal>

    <!-- 添加品牌形象 -->
    <AddBrandModal v-model="showAddBrandModal" v-bind="brandModalAccount" @add-confirm="getBrandsList"></AddBrandModal>

    <el-dialog
      :visible.sync="selectorModal"
      custom-class="material-selector-dialog"
      :close-on-click-modal="false"
      title="选择素材"
      width="1200px"
      append-to-body
      @close="onSelectorClose"
    >
      <AssetsSelector
        v-bind="{ ...selectorProps, visible: selectorModal, adAccountId, selectedGameId: planForm.game_id.id }"
        :before-submit="selectorBeforeSubmit"
        @close="onSelectorClose"
        @confirm="onSelectorConfirm"
      >
        <template v-slot:assetType="{ getData }">
          <el-radio
            v-if="isCarouselSelectMode"
            v-model="selectorProps.assetType"
            @change="getData"
            :label="MATERIAL_TYPE_ID[carouselMaterialType]"
          >
            {{ isCarouselThreeImage ? '图片' : '视频' }}
          </el-radio>
          <template v-else>
            <el-radio
              v-model="selectorProps.assetType"
              :disabled="radioDisabled.video"
              @change="getData"
              :label="MATERIAL_TYPE_ID[MATERIAL_TYPE.VIDEO]"
            >
              视频
            </el-radio>
            <el-radio
              v-model="selectorProps.assetType"
              :disabled="radioDisabled.image"
              @change="getData"
              :label="MATERIAL_TYPE_ID[MATERIAL_TYPE.IMAGE]"
            >
              图片
            </el-radio>

            <el-radio
              v-model="selectorProps.assetType"
              :disabled="radioDisabled.group_image"
              @change="getData"
              :label="MATERIAL_TYPE_ID[MATERIAL_TYPE.GROUP_IMAGE]"
            >
              组图
            </el-radio>

            <el-radio
              v-model="selectorProps.assetType"
              :disabled="radioDisabled.poster"
              @change="getData"
              :label="MATERIAL_TYPE_ID[MATERIAL_TYPE.POSTER]"
            >
              封面
            </el-radio>

            <el-radio
              v-model="selectorProps.assetType"
              :disabled="radioDisabled.logo"
              @change="getData"
              :label="MATERIAL_TYPE_ID[MATERIAL_TYPE.LOGO]"
            >
              LOGO
            </el-radio>

            <el-radio v-model="selectorProps.assetType" @change="getData" :label="MATERIAL_TYPE_ID[MATERIAL_TYPE.FAV]"> 个人收藏 </el-radio>
          </template>
        </template>

        <template v-slot:mediatag="{ width }" v-if="materialTagList && materialTagList.length">
          <el-select :style="{ width }" popper-class="creative-selector-el-select-popper" :value="selectorProps.form.media_tag" disabled>
            <el-option v-for="item in materialTagList" :key="item.tagId" :label="item.mediaTagName" :value="item.tagId"> </el-option>
          </el-select>
        </template>

        <template v-slot:sizes="{ getData, width }">
          <el-select
            :style="{ width }"
            popper-class="creative-selector-el-select-popper"
            :popper-append-to-body="false"
            v-model="selectorProps.form.size"
            clearable
            @change="getData"
          >
            <!-- 根据当前选择素材的类型来获取尺寸下拉数据 -->
            <el-option
              v-for="item in MATERIAL_TYPE_SIZES_V3[selectorProps.assetType]"
              :key="item.label"
              :label="item.label"
              :value="item.label"
            >
            </el-option>
          </el-select>
        </template>
      </AssetsSelector>
    </el-dialog>
  </div>
</template>

<script>
import { toRef } from 'vue'
import moment from 'moment'
import { groupBy } from '@/common/js/just.js'
import { MEDIAS } from '@/common/js/constants.js'
import { getBarrageList, getXijingPages, getGdtOfficialPages, getPromotedObject } from '@/api/tencent.model'
import { getProfiles, getBrands } from '@/api/tencent.local.model'
import { PLATFORM, IMG_URL_MD5_REGEXP } from '@/views/create/gdt/model/project-const.js'

import ComponentBasedCreativeForm from './creative-form.vue'
// 创意组件
import CreativeTemplateComponents from '@/views/create/gdt/template/components/creative/components/creative-form/creative-form-components.vue'

import AddProfileModal from '@/views/create/gdt/components/distribute/components/profile/add-profile-modal.vue'
import AddBrandModal from '@/views/create/gdt/components/distribute/components/profile/add-brand-modal.vue'
import LabelModal from '@/views/create/gdt/components/creative/label.vue'
import LandingPageTagGroup from '@/views/create/gdt/components/distribute/components/pages-v3/tag-group.vue'
import { AssetsSelector, makeSelectorForm } from '@/components/material-selector/index.js'
import { MATERIAL_TYPE_ID, MATERIAL_TYPE } from '@/components/material-selector/consts.js'
import {
  MATERIAL_TYPE_SIZES_V3,
  MATERIAL_IMAGE_GROUP_TYPE,
  SELECTOR_TYPE,
  MATERIAL_SIZES
} from '@/views/create/gdt/model/creative-const.js'
import { IMAGE_TYPES, IMAGE_STYLE } from '@/views/material/uploading/consts.js'
import { uploadMetarial } from '@/api/material.model'
import { getCarouselMaterialType, useGdtCreativeComputes } from '@/views/create/gdt/template/hooks/utils/creative.js'
export default {
  props: {
    group: Object,
    groups: Array,
    creativeGroupIndex: Number,
    // 素材标签id，过滤素材选择
    materialPackageId: [Number, String],
    materialTagList: {
      type: Array,
      default: () => []
    }
  },
  inject: ['creativeInstance'],
  provide() {
    return {
      localStates: {
        getAdAccount: () => ({ id: this.adAccountId })
      }
    }
  },
  components: {
    ComponentBasedCreativeForm,
    CreativeTemplateComponents,
    AddProfileModal,
    AddBrandModal,
    AssetsSelector,
    LabelModal,
    LandingPageTagGroup,
    ImageMaterial: () => import('../image.vue'),
    VideoMaterial: () => import('../video.vue')
  },
  setup(props) {
    const { isCarouselThreeImage, isCarouselThreeVideo, carouselMaterialType } = useGdtCreativeComputes(toRef(props, 'group'))
    return { isCarouselThreeImage, isCarouselThreeVideo, carouselMaterialType }
  },
  computed: {
    planForm() {
      return this.creativeInstance.planForm
    },
    isIOS() {
      return this.planForm.ch_platform_id === PLATFORM.IOS
    },
    isAndroid() {
      return this.planForm.ch_platform_id === PLATFORM.ANDROID
    },
    isMiniGame() {
      return this.planForm.ch_platform_id === PLATFORM.MINIGAME
    },
    pageStates() {
      return this.creativeInstance.pageStates
    },
    adAccountId() {
      const [account] = this.planForm.accounts
      return account || 0
    },
    materialLen() {
      const { selectedAssets } = this.group
      const imageLen = selectedAssets.image?.length || 0
      const videoLen = selectedAssets.video?.length || 0
      const imageListLen = selectedAssets.image_list?.length || 0
      return imageLen + videoLen + imageListLen
    },
    selectorBeforeSubmit() {
      if (this.uploadGroupImageMode) return this.onProceduralSelectorBeforeSubmit
      const isCarouselMaterialReplace = Boolean(
        this.carouselMaterialType && this.materialReplaceModel && this.materialReplaceModel.assetType !== MATERIAL_TYPE.POSTER
      )
      if (this.isCarouselSelectMode || isCarouselMaterialReplace) {
        return this.onCarouselSelectorBeforeSubmit
      }
      return null
    },
    radioDisabled() {
      const { assetType } = this.selectorProps
      const { assetType: replaceAssetType } = this.materialReplaceModel || {}
      const { POSTER, LOGO } = MATERIAL_TYPE
      const disabledStates = {
        image: true,
        group_image: true,
        poster: true,
        logo: true,
        video: true
      }

      if (this.isNormalMode) {
        disabledStates.image = false
        disabledStates.video = false
        disabledStates.group_image = false
      }

      if (this.uploadGroupImageMode) {
        disabledStates.image = false
      }

      if (this.selectGroupImageMode) {
        disabledStates.group_image = false
      }

      if (MATERIAL_TYPE_ID[LOGO] === assetType) {
        disabledStates.logo = false
      }

      // 选择试玩结束页的特殊处理，可以同时选logo和图片作为试玩结束页
      if (this.iconType === SELECTOR_TYPE.WXGAME_PLAYABLE) {
        disabledStates.image = false
        disabledStates.logo = false
      }

      if (MATERIAL_TYPE_ID[POSTER] === assetType || replaceAssetType) {
        // 更换封面可以同时选择图片和封面
        if (replaceAssetType === POSTER) {
          disabledStates.poster = false
        }
        // 替换图片时只能选择图片
        disabledStates.image = false
      }

      return disabledStates
    },
    currLandingPageItem() {
      const pageInfo = this.groups[this.creativeGroupIndex]?.pageInfo
      if (!pageInfo) return {}

      // 避免每个复制任务的落地页个数不一致导致来回切换时找不到对应的索引报错
      const len = pageInfo.length
      const tagIndex = len < this.landingPageActiveTag ? len - 1 : this.landingPageActiveTag
      this.$set(this, 'landingPageActiveTag', tagIndex)
      return pageInfo[tagIndex]
    },
    taskId() {
      return this.$parent.currTask.taskId
    },
    brandModalAccount() {
      return { accountId: this.planForm.accounts[0] }
    }
  },
  data() {
    return {
      MATERIAL_TYPE_ID,
      MATERIAL_TYPE_SIZES_V3,
      MATERIAL_IMAGE_GROUP_TYPE,
      MATERIAL_TYPE,
      SELECTOR_TYPE,
      labelModal: false,
      showAddProfileModal: false, // 是否显示添加品牌简介页弹窗
      showAddBrandModal: false, // 是否显示添加品牌弹窗
      getProfileListLoading: false,
      getBrandListLoading: false,
      brandList: [], // 品牌形象下拉数据
      profileList: [], // 品牌简介页下拉数据
      barrageList: [], // 品牌简介页下拉数据
      xijingPages: [], // 蹊径落地页下拉数据
      officialPages: [], // 官方落地页下拉数据
      promotedObjectChannelList: [], // 视频号下拉数据
      officialAccountList: [], // 公众号下拉数据
      materialReplaceModel: null, // 替换素材时，保存的素材临时数据
      isCarouselSelectMode: false, // 轮播三图/三视频素材选择模式
      selectGroupImageMode: false, // 选择组图模式
      uploadGroupImageMode: false, // 是否组图上传
      proceduralImageType: 0, // 组图类型
      selectorModal: false,
      iconType: '',
      wxgamePlayableFlag: '',
      selectorProps: {
        max: 15,
        videoId: 0, // 获取视频封面对应的视频id，替换已选视频封面时传入
        assetType: MATERIAL_TYPE_ID[MATERIAL_TYPE.VIDEO] // 1单图 2双图 3三图 4视频 6头条视频 7头条图片 8LOGO
      },
      landingPageActiveTag: 0
    }
  },
  watch: {
    // 批量复制，切换任务时，如果账号变更，重新获取落地页、头像昵称、品牌形象跳转、视频号
    adAccountId() {
      this.getXijingPageList()
      this.getBrandsList()
      this.getProfileList()
      this.getPromotedObjectList()
      this.getOffcialAccountList()
    },
    // 当落地页类型变更时，可能会涉及到promoted_object_type变更，需要重新获取落地页
    'currLandingPageItem.pageType'() {
      this.getXijingPageList()
    },
    'planForm.promotedObject.promoted_object_type'() {
      this.getXijingPageList()
    }
  },
  methods: {
    /**
     * @description: 打开组图选择
     * @return {*}
     */
    showProceduralImageSelector(imageType) {
      this.selectorProps = {
        ...this.selectorProps,
        max: imageType,
        videoId: 0,
        assetType: MATERIAL_TYPE_ID[MATERIAL_TYPE.IMAGE],
        form: { ...makeSelectorForm(), size: '800*800', media_tag: this.materialPackageId, media_id: MEDIAS.GDT }
      }
      this.uploadGroupImageMode = true
      this.proceduralImageType = imageType
      this.selectorModal = true
    },
    onProceduralSelectorBeforeSubmit(images, callbacks) {
      const { done, fail } = callbacks || {}
      let msg = ''
      switch (this.proceduralImageType) {
        case MATERIAL_IMAGE_GROUP_TYPE.THREE_IMAGE:
          if (images.length !== 3) msg = '请选择3张图片'
          break
        case MATERIAL_IMAGE_GROUP_TYPE.FOUR_IMAGE:
          if (images.length !== 4) msg = '请选择4张图片'
          break
        case MATERIAL_IMAGE_GROUP_TYPE.SIX_IMAGE:
          if (images.length !== 6) msg = '请选择6张图片'
          break
        default:
          if (images.length !== 9) msg = '请选择9张图片'
          break
      }

      // 判断图片类型是否相同
      const suffix = images[0].url.split('.').pop()
      const isSameSuffix = images.every((item) => {
        const suf = item.url.split('.').pop()
        return suf === suffix
      })

      if (!isSameSuffix) msg = '请选择同类型图片'

      // 判断图片尺寸是否相同
      const { width, height } = images[0]
      const shape = `${width}*${height}`
      const isSameShape = images.every((item) => {
        const { width, height } = item
        const sh = `${width}*${height}`
        return sh === shape
      })
      if (!isSameShape) msg = '请选择同尺寸图片'

      msg ? fail(msg) : done()
    },
    /**
     * @description: 显示选择创意素材弹窗
     */
    showCreativeSelector() {
      this.selectorProps = {
        ...this.selectorProps,
        max: 15 - this.materialLen,
        videoId: 0,
        assetType: MATERIAL_TYPE_ID[MATERIAL_TYPE.VIDEO],
        form: { ...makeSelectorForm(), size: '', media_tag: this.materialPackageId, media_id: MEDIAS.GDT }
      }
      this.isNormalMode = true
      this.selectorModal = true
    },

    showCarouselSelector() {
      this.selectorProps = {
        ...this.selectorProps,
        max: Math.max(3 - this.materialLen, 0),
        videoId: 0,
        assetType: MATERIAL_TYPE_ID[this.carouselMaterialType],
        form: { ...makeSelectorForm(), size: '', media_tag: this.materialPackageId, media_id: MEDIAS.GDT }
      }
      this.isCarouselSelectMode = true
      this.selectorModal = true
    },

    onCarouselSelectorBeforeSubmit(assets, callbacks) {
      const { done, fail } = callbacks || {}
      const materialType = this.carouselMaterialType
      const materialName = materialType === MATERIAL_TYPE.IMAGE ? '图片' : '视频'

      if (!assets.length || assets.some((item) => item.type !== materialType)) {
        return fail && fail(`轮播三${materialName === '图片' ? '图' : '视频'}只能选择${materialName}素材`)
      }

      const currentMaterials = this.group.selectedAssets?.[materialType] || []
      if (this.materialReplaceModel) {
        if (assets.length !== 1) return fail && fail(`请选择1个${materialName}素材`)
        const materials = [...currentMaterials]
        materials.splice(this.materialReplaceModel.index, 1, assets[0])
        if (!this.hasSameMaterialSize(materials)) {
          return fail && fail(`同一创意组的3个${materialName}素材宽高尺寸必须一致`)
        }
        return done && done()
      }

      const remainingCount = Math.max(3 - this.materialLen, 0)
      const missingCount = Math.max(remainingCount - assets.length, 0)
      const materials = [...currentMaterials, ...assets]
      if (assets.length !== remainingCount) {
        return fail && fail(`每个创意组必须选择3个${materialName}素材，当前还需选择${missingCount}个`)
      }
      if (!this.hasSameMaterialSize(materials)) {
        return fail && fail(`同一创意组的3个${materialName}素材宽高尺寸必须一致`)
      }
      done && done()
    },

    hasSameMaterialSize(materials) {
      if (!materials.length || materials.some((item) => Number(item.width) <= 0 || Number(item.height) <= 0)) return false
      return new Set(materials.map((item) => `${Number(item.width)}*${Number(item.height)}`)).size === 1
    },

    showCreativeGroupImageSelector() {
      this.selectorProps = {
        ...this.selectorProps,
        max: 15 - this.materialLen,
        assetType: MATERIAL_TYPE_ID[MATERIAL_TYPE.GROUP_IMAGE],
        form: { ...makeSelectorForm(), size: '800*800', media_tag: this.materialPackageId, media_id: MEDIAS.GDT }
      }
      this.selectGroupImageMode = true
      this.selectorModal = true
    },

    /**
     * @description: 显示选择创意素材替换弹窗（替换单个视频、图片、封面）
     */
    showCreativeReplaceSelector(asset, assetType) {
      const props = {
        ...this.selectorProps,
        max: 1,
        assetType: MATERIAL_TYPE_ID[assetType],
        form: { ...makeSelectorForm(), size: `${asset.width}*${asset.height}` }
      }

      // 替换封面时，传入视频id
      if (assetType === MATERIAL_TYPE.POSTER) {
        // inner_video_id 在获取媒体素材时生成，src/components/material-selector/utils.js
        const { id, inner_video_id } = asset
        props.videoId = this.pageStates?.isUpdateCreative ? inner_video_id : id
      }
      this.selectorProps = props
      this.selectorModal = true
    },

    /**
     * @description: 重新选择视频、图片、封面等
     * @param {*} assetType 素材类型
     * @param {*} asset 素材
     * @param {*} index 在已选素材的位置
     */
    onMaterialReplace(assetType, asset, index) {
      this.materialReplaceModel = {
        index,
        assetType
      }
      this.showCreativeReplaceSelector(asset, assetType)
    },

    /**
     * @description: 创意组件浮层卡片logo图片选择弹窗
     * @return {*}
     */
    showFloatingZoneIconSelector() {
      this.selectorProps = {
        ...this.selectorProps,
        max: 1,
        assetType: MATERIAL_TYPE_ID[MATERIAL_TYPE.LOGO],
        form: { ...makeSelectorForm(), size: MATERIAL_SIZES.SIZE_800_800, media_id: MEDIAS.GDT }
      }
      this.iconType = SELECTOR_TYPE.FLOATING_ZONE
      this.selectorModal = true
    },
    /**
     * @description: 创意组件试玩页logo图片选择弹窗
     * @return {*}
     */
    showWxgamePlayableIconSelector() {
      this.selectorProps = {
        ...this.selectorProps,
        max: 1,
        assetType: MATERIAL_TYPE_ID[MATERIAL_TYPE.IMAGE],
        form: { ...makeSelectorForm(), size: MATERIAL_SIZES.SIZE_1280_720, media_id: MEDIAS.GDT }
      }
      this.iconType = SELECTOR_TYPE.WXGAME_PLAYABLE
      this.selectorModal = true
    },

    /**
     * @description: 创意组件试玩页logo图片选择弹窗
     * @return {*}
     */
    showWxgamePlayableImageSelector() {
      this.selectorProps = {
        ...this.selectorProps,
        max: 1,
        assetType: MATERIAL_TYPE_ID[MATERIAL_TYPE.IMAGE],
        form: { ...makeSelectorForm(), size: MATERIAL_SIZES.SIZE_800_800, media_id: MEDIAS.GDT }
      }
      this.iconType = SELECTOR_TYPE.WXGAME_PLAYABLE
      this.wxgamePlayableFlag = 'card_link_image'
      this.selectorModal = true
    },

    /**
     * @description: 创意组件试玩页logo图片选择弹窗
     * @return {*}
     */
    showWxgamePlayableEndImageSelector() {
      this.selectorProps = {
        ...this.selectorProps,
        max: 1,
        assetType: MATERIAL_TYPE_ID[MATERIAL_TYPE.IMAGE],
        form: { ...makeSelectorForm(), size: MATERIAL_SIZES.SIZE_1280_720, media_id: MEDIAS.GDT }
      }
      this.iconType = SELECTOR_TYPE.WXGAME_PLAYABLE
      this.wxgamePlayableFlag = 'end_cover_img'
      this.selectorModal = true
    },

    /**
     * @description: 创意组件图文链接logo图片选择弹窗
     * @return {*}
     */
    showMiniCardIconSelector() {
      this.selectorProps = {
        ...this.selectorProps,
        max: 1,
        assetType: MATERIAL_TYPE_ID[MATERIAL_TYPE.LOGO],
        form: { ...makeSelectorForm(), size: MATERIAL_SIZES.SIZE_800_800, media_id: MEDIAS.GDT }
      }
      this.iconType = SELECTOR_TYPE.MINI_CARD_LINK
      this.selectorModal = true
    },
    /**
     * @description: logo类型素材
     * @param {*} assets
     */
    handleLogoSelect(assets) {
      const components = this.group.components

      if (this.iconType === SELECTOR_TYPE.FLOATING_ZONE) {
        components.floating_zone.floating_zone_image = assets[0]
      }
      if (this.iconType === SELECTOR_TYPE.MINI_CARD_LINK) {
        components.mini_card_link.mini_card_link_image = assets[0]
      }
      if (this.iconType === SELECTOR_TYPE.WXGAME_PLAYABLE) {
        if (this.wxgamePlayableFlag) {
          components.wxgame_playable_component[this.wxgamePlayableFlag] = assets[0]
        } else {
          components.wxgame_playable_page.wxgame_playable_page_end_cover_img = assets[0]
        }
      }
      this.updateGroup({ ...this.group, components })
      this.onCreativeFormClearValidate('components.floating_zone')
      this.iconType = ''
      this.wxgamePlayableFlag = ''
    },

    onSelectorConfirm(assets) {
      console.log('this.selectorProps output: ', this.selectorProps)
      console.log('assetsassets output: ', assets)
      switch (this.selectorProps.assetType) {
        case MATERIAL_TYPE_ID[MATERIAL_TYPE.LOGO]:
          this.handleLogoSelect(assets)
          break

        default:
          if (this.uploadGroupImageMode) {
            this.handleProceduralImageSelect(assets)
          } else if (this.iconType === SELECTOR_TYPE.WXGAME_PLAYABLE) {
            this.handleLogoSelect(assets)
          } else {
            this.handleMaterialSelect(assets)
          }

          break
      }
      this.onSelectorClose()
    },

    /**
     * @description: 处理组图选择
     * @param {*} assets
     * @return {*}
     */
    async handleProceduralImageSelect(imageList) {
      if (!imageList.length) return
      const [firstImage] = imageList
      const maxSize = Math.max(...imageList.map((img) => img.size))
      const groupImageMd5s = imageList
        .map((i) => {
          const [_, md5] = IMG_URL_MD5_REGEXP.exec(i.url) || []
          return md5
        })
        .filter(Boolean)
        .join(',')
      const groupImageUrls = imageList.map((i) => i.url).join(',')
      const fileInfos = [
        {
          width: firstImage.width,
          height: firstImage.height,
          nameSysFlag: 1,
          name: `${firstImage.name}.${firstImage.url.split('.').pop()}`,
          size: maxSize,
          groupImageMd5s,
          groupImageUrls
        }
      ]

      try {
        // 保存组图到素材库
        const [res] = await uploadMetarial({
          gameIds: this.planForm.game_id.id,
          imageStyles: IMAGE_STYLE.GRAPHIC,
          imageType: IMAGE_TYPES.GROUP_IMAGE,
          source: 1,
          lauchTime: moment().format('YYYY-MM-DD'),
          fileInfos
        })

        const { imageDetailId } = res
        const selectedMaterials = {
          ...this.group.selectedAssets
        }
        if (!selectedMaterials.image_list) {
          selectedMaterials.image_list = []
        }

        selectedMaterials.image_list.push({
          id: imageDetailId,
          // 占位图片
          preview_url: 'https://ptom-resource-cos.caohua.com/ptom/advResource/video/209159/75ea19ac3e03ce8c0e4f8b6586189cbd.png',
          type: 'image_list',
          placeholder: true
        })

        this.updateGroup({ ...this.group, selectedAssets: selectedMaterials })
      } catch (e) {
        console.log('uploadMetarial error output: ', e)
      }
    },

    /**
     * @description: 视频图片创意素材选择后处理结构
     * @param {*} assets
     */
    handleMaterialSelect(assets) {
      // 替换
      if (this.materialReplaceModel) {
        // 视频、图片（组图）、封面
        const { index, assetType } = this.materialReplaceModel
        const [asset] = assets

        const selectedAssets = this.group.selectedAssets

        switch (assetType) {
          case MATERIAL_TYPE.VIDEO:
            asset.video_replaced = true
            selectedAssets.video[index] = asset
            break
          case MATERIAL_TYPE.POSTER:
            selectedAssets.video[index] = {
              ...selectedAssets.video[index],
              cover_id: asset.id,
              // cover_url: asset.preview_url,
              cover_width: asset.width,
              cover_height: asset.height,
              cover_size: asset.cover_size,
              replaced_cover_url: asset.preview_url,
              cover_replaced: true,
              cover_replaced_type: asset.type
            }
            break
          case MATERIAL_TYPE.IMAGE:
            selectedAssets.image[index] = asset
            break
          default:
            break
        }

        this.updateGroup({ ...this.group, selectedAssets })
      } else {
        // 新增
        const selectedAssets = this.group.selectedAssets
        if (this.isCarouselSelectMode) {
          const materialType = this.carouselMaterialType
          const currentMaterials = selectedAssets[materialType] || []
          const carouselAssets = assets.filter((item) => item.type === materialType).slice(0, Math.max(3 - currentMaterials.length, 0))
          this.updateGroup({
            ...this.group,
            selectedAssets: {
              image: materialType === MATERIAL_TYPE.IMAGE ? currentMaterials.concat(carouselAssets) : [],
              video: materialType === MATERIAL_TYPE.VIDEO ? currentMaterials.concat(carouselAssets) : [],
              image_list: []
            }
          })
          this.onCreativeFormClearValidate('selectedAssets')
          return
        }
        const existAssets = Object.values(selectedAssets).flat()
        assets = assets.slice(0, 15 - existAssets.length)
        const newAssets = groupBy(assets, (i) => i.type)

        if (selectedAssets.image?.length) {
          if (!newAssets.image) newAssets.image = []
          newAssets.image = selectedAssets.image.concat(newAssets.image)
        }
        if (selectedAssets.video?.length) {
          if (!newAssets.video) newAssets.video = []
          newAssets.video = selectedAssets.video.concat(newAssets.video)
        }
        if (selectedAssets.image_list?.length) {
          if (!newAssets.image_list) newAssets.image_list = []
          newAssets.image_list = selectedAssets.image_list.concat(newAssets.image_list)
        }
        this.updateGroup({ ...this.group, selectedAssets: newAssets })
      }
      this.onCreativeFormClearValidate('selectedAssets')
    },

    updateGroup(group) {
      this.$emit('update:group', group)
    },
    /**
     * @description: 清空全部已选素材
     */
    clearAllSelectedMaterials() {
      this.updateGroup({
        ...this.group,
        selectedAssets: {
          image: [],
          video: []
        }
      })
    },

    onLandingPageTypeChange() {
      const pageInfo = this.groups[this.creativeGroupIndex].pageInfo.map((i, index) => {
        if (index === this.landingPageActiveTag) return { ...i, page: {} }
        return i
      })
      this.updateGroup({ ...this.group, pageInfo })
    },
    onAddLandingPageTag() {
      const pageInfo = this.groups[this.creativeGroupIndex].pageInfo
      let pageType = 0
      if (this.isIOS) pageType = 3
      if (this.isAndroid) pageType = 2
      if (this.isMiniGame) pageType = 4
      pageInfo.push({
        pageType,
        page: {}
      })
      this.updateGroup({ ...this.group, pageInfo })
      this.landingPageActiveTag = pageInfo.length - 1
    },
    onRemoveLandingPageTag(index) {
      const pageInfo = this.groups[this.creativeGroupIndex].pageInfo
      const newPageInfo = pageInfo.filter((item, i) => i !== index)
      this.updateGroup({ ...this.group, pageInfo: newPageInfo })

      if (newPageInfo.length > index) {
        this.landingPageActiveTag = index
      } else {
        this.landingPageActiveTag = newPageInfo.length - 1
      }
    },

    /**
     * @description: 选择标签
     */
    onConfirmLabels(labels) {
      const components = this.group.components
      components.label = labels
      this.updateGroup({ ...this.group, components })
    },
    onClearRemove() {
      const components = this.group.components
      components.label = []
      this.updateGroup({ ...this.group, components })
    },

    /**
     * @description: 清除校验
     */
    onCreativeFormClearValidate(fields) {
      const [elForm] = this.$refs['creative-form'][this.creativeGroupIndex].$children
      if (elForm) elForm.clearValidate(fields)
    },

    /**
     * @description: 删除单个已选素材
     * @param {*} imgItem
     */
    onSelectedItemRemove(index, type) {
      const selectedAssets = this.group.selectedAssets
      selectedAssets[type] = selectedAssets[type].filter((_, _index) => _index !== index)
      this.updateGroup({ ...this.group, selectedAssets })
    },
    onSelectorClose() {
      // 清除记录替换素材的标识
      this.materialReplaceModel = null

      this.uploadGroupImageMode = false
      this.selectGroupImageMode = false
      this.isCarouselSelectMode = false
      this.isNormalMode = false

      this.selectorModal = false
    },
    /**
     * @description: 获取头像昵称
     */
    getProfileList() {
      const { promotedObject } = this.planForm
      this.getProfileListLoading = true
      getProfiles({
        ad_account_id: this.adAccountId,
        promoted_object_id: promotedObject.promoted_object_id
      })
        .then((data) => {
          this.profileList = data
          this.getProfileListLoading = false

          // 切换账号时，如果当前账号获取的列表不包含之前选中的品牌简介页，清除已选中
          const components = this.group.components
          const { profile_id } = components.brand?.profileInfo || {}
          if (profile_id) {
            if (!data.find((i) => i.profile_id === profile_id)) {
              components.brand.profileInfo = {}
              this.updateGroup({ ...this.group, components })
            }
          }
        })
        .catch(() => {})
    },
    /**
     * @description: 品牌形象下拉列表
     */
    getBrandsList() {
      setTimeout(() => {
        this.getBrandListLoading = true
        getBrands({ ad_account_id: this.adAccountId }).then((data) => {
          const brandList = []
          // 数组根据image_id去重，因为品牌形象model通过value-key="image_id"指定，重复的image_id会导致渲染错误；
          for (const item of data) {
            if (!brandList.find((i) => i.image_id === item.image_id)) {
              brandList.push(item)
            }
          }

          // 切换账号时，如果当前账号不包含之前选中的品牌形象，清除已选中
          const components = this.group.components
          const { image_id } = components.brand?.brandInfo || {}
          if (image_id) {
            if (!brandList.find((i) => i.image_id === image_id)) {
              components.brand.brandInfo = {}
              this.updateGroup({ ...this.group, components })
            }
          }
          this.brandList = brandList
          this.getBrandListLoading = false
        })
      }, 200)
    },
    /**
     * @description: 获取弹幕
     */
    getComponentsBarrageList() {
      getBarrageList({ ad_account_id: this.adAccountId }).then((data) => {
        this.barrageList = data
      })
    },
    /**
     * @description: 视频号列表
     */
    getPromotedObjectList() {
      getPromotedObject({ ad_account_id: this.adAccountId, promoted_object_type: 'PROMOTED_OBJECT_TYPE_WECHAT_CHANNELS' }).then((data) => {
        this.promotedObjectChannelList = data || []

        // 切换账号时，如果当前账号不包含之前选中的视频号，清除已选中
        const components = this.group.components
        const { promoted_object_id } = components.wechat_channels?.channelInfo || {}
        if (promoted_object_id) {
          if (!this.promotedObjectChannelList.find((i) => i.promoted_object_id === promoted_object_id)) {
            components.wechat_channels.channelInfo = {}
            this.updateGroup({ ...this.group, components })
          }
        }
      })
    },
    getOffcialAccountList() {
      getPromotedObject({ ad_account_id: this.adAccountId, promoted_object_type: 'PROMOTED_OBJECT_TYPE_WECHAT_OFFICIAL_ACCOUNT' }).then(
        (data) => {
          this.officialAccountList = data || []
        }
      )
    },
    getXijingPageList() {
      const { promotedObject } = this.planForm
      const { promoted_object_type, promoted_object_id } = promotedObject
      const params = {
        ad_account_id: this.adAccountId,
        promoted_object_type,
        promoted_object_id
      }
      getXijingPages(params).then((data) => {
        this.xijingPages = data
      })
      getGdtOfficialPages(params).then((data) => {
        this.officialPages = data
      })
    },
    onPageTypeChange() {
      const pageInfo = this.group.pageInfo
      pageInfo[0].page.page_id = ''
      this.updateGroup({ ...this.group, pageInfo })
    },

    /**
     * @description: 创意组校验
     * @return {*}
     */
    async formValidate() {
      const formRefs = this.$refs['creative-form']
      let invalidRefIndex = -1
      try {
        for (const i in formRefs) {
          const [formRef] = formRefs[i].$children
          invalidRefIndex = Number(i)
          const group = this.groups[i]
          const carouselMaterialType = getCarouselMaterialType(group)
          if (carouselMaterialType) {
            const materialName = carouselMaterialType === MATERIAL_TYPE.IMAGE ? '图片' : '视频'
            const carouselMaterials = group.selectedAssets?.[carouselMaterialType] || []
            const materialLen = Object.values(group.selectedAssets || {}).flat().length
            if (materialLen !== 3 || carouselMaterials.length !== 3) {
              this.$message.error(`轮播三${materialName === '图片' ? '图' : '视频'}必须选择3个${materialName}素材`)
              throw new Error('invalid carousel material count')
            }
            if (!this.hasSameMaterialSize(carouselMaterials)) {
              this.$message.error(`轮播三${materialName === '图片' ? '图' : '视频'}的3个${materialName}素材宽高尺寸必须一致`)
              throw new Error('invalid carousel material size')
            }
          }
          await formRef.validate()
        }
        return Promise.resolve()
      } catch (e) {
        return Promise.reject(invalidRefIndex)
      }
    }
  },
  created() {
    this.getBrandsList()
    this.getProfileList()
    this.getXijingPageList()
    this.getComponentsBarrageList()
    this.getPromotedObjectList()
    this.getOffcialAccountList()
  }
}
</script>

<style lang="scss" scoped>
.selected-materials {
  .selected-images,
  .selected-image-groups,
  .selected-videos {
    margin-bottom: 5px;
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    position: relative;
  }
}

.upload-row {
  margin-bottom: 10px;
  display: flex;
}

.no-material {
  background: #f9f9f9;
  line-height: 220px;
  text-align: center;
  border-radius: 10px;
  font-size: 12px;
}
</style>
